exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results--WhVL3 {\n  position: absolute;\n  border-top: 1px solid #e6e6e6;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  z-index: 10;\n}\n\n.results--WhVL3 .item--UYrWP {\n  padding: 8px;\n  text-align: left;\n  background-color: #fff;\n  cursor: pointer;\n}\n\n.results--WhVL3 .item--UYrWP.active--2EdGf {\n  background-color: #fafafa;\n}\n\n", ""]);

// exports
exports.locals = {
	"results": "results--WhVL3",
	"item": "item--UYrWP",
	"active": "active--2EdGf"
};